import React from 'react';
import '../../styles/Features.css';
import {
  Settings,
  BarChart3,
  Smartphone,
  Factory,
  BrainCircuit,
  Handshake
} from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
  color: string;
}

const Features: React.FC = () => {
  const { t } = useLanguage();
  const features: Feature[] = [
    {
      icon: <Settings className="w-8 h-8" />,
      title: t('features.module1.title'),
      description: t('features.module1.description'),
      color: "from-blue-500 to-blue-600"
    },
    {
      icon: <BarChart3 className="w-8 h-8" />,
      title: t('features.module2.title'),
      description: t('features.module2.description'),
      color: "from-purple-500 to-purple-600"
    },
    {
      icon: <Smartphone className="w-8 h-8" />,
      title: t('features.module3.title'),
      description: t('features.module3.description'),
      color: "from-green-500 to-green-600"
    },
    {
      icon: <Factory className="w-8 h-8" />,
      title: t('features.module4.title'),
      description: t('features.module4.description'),
      color: "from-red-500 to-red-600"
    },
    {
      icon: <BrainCircuit className="w-8 h-8" />,
      title: t('features.module5.title'),
      description: t('features.module5.description'),
      color: "from-cyan-500 to-cyan-600"
    },
    {
      icon: <Handshake className="w-8 h-8" />,
      title: t('features.module6.title'),
      description: t('features.module6.description'),
      color: "from-amber-500 to-amber-600"
    }
  ];

  return (
    <section id="features" className="features">
      <div className="container">
        <div className="section-header">
          <h2>{t('features.title')}</h2>
          <p>
            {t('features.description')}
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              
              <h3>{feature.title}</h3>
              
              <p>{feature.description}</p>

              <div className="feature-gradient" style={{ background: `linear-gradient(135deg, ${feature.color})` }}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;